import React from 'react';
import PropTypes from 'prop-types';

import { Image } from 'nordic/image';

import { UI_LANDING_STYLE_PREFIX } from '../../../constants/appConstants';

const CarouselImages = (props) => {
  const { value } = props;

  const namespace = `${UI_LANDING_STYLE_PREFIX}-carousel-images`;

  if (!value || !Array.isArray(value.images) || value.images.length === 0) {
    return undefined;
  }

  const { url, alt, fallback_image_url: fallbackImage } = value.images[0];

  const finalImageUrl = url || fallbackImage;

  return (
    <div className={namespace}>
      <Image
        lazyload="off"
        className={`${namespace}-img`}
        alt={alt}
        src={finalImageUrl}
        srcFallback={fallbackImage}
      />
    </div>
  );
};

CarouselImages.propTypes = {
  value: PropTypes.shape({
    images: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
        fallback_image_url: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
};

export default CarouselImages;
